import VueLuckyCanvas from "@lucky-canvas/vue";
// import vueDevtools from "@vue/devtools";
import Vant from "vant";
import "vant/lib/index.css";
import Vue from "vue";
import App from "./App.vue";
import * as directive from "./assets/js/directive.js";
import * as filter from "./assets/js/filter.js";
import "./assets/scss/common.scss";
import "./plugins/vant.js";
import router from "./router";
import store from "./store";

Vue.use(VueLuckyCanvas);
Vue.use(Vant);
Object.keys(filter.default).forEach(key => {
  Vue.filter(key, filter.default[key]);
});

Object.keys(directive.default).forEach(key => {
  Vue.directive(key, directive.default[key]);
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
